import {
  ListingMenuEnum,
  ListingPriceTypeEnum,
  ListingStatusEnum
} from 'src/enums';

export const listingPriceTypeOptions: { name: string; value: number }[] = [
  {
    name: 'Not Free (Default)',
    value: ListingPriceTypeEnum.NotFree
  },
  {
    name: 'Free from supplier',
    value: ListingPriceTypeEnum.FreeFromSupplier
  },
  {
    name: 'Free for all',
    value: ListingPriceTypeEnum.FreeForAll
  }
];

export const listingStatusOptions: {
  name: string;
  value: string;
  permissions?: string[];
}[] = [
  {
    name: 'Available',
    value: ListingStatusEnum.Available,
    permissions: ['can_update_listings_status']
  },
  {
    name: 'Purchased',
    value: ListingStatusEnum.Purchased,
    permissions: ['can_update_listings_status']
  },
  {
    name: 'Hold',
    value: ListingStatusEnum.OnHold,
    permissions: []
  },
  {
    name: 'Transfer',
    value: ListingStatusEnum.Transfer,
    permissions: []
  },
  {
    name: 'Defective',
    value: ListingStatusEnum.Defective,
    permissions: ['can_update_listings_status', 'can_update_listings_defective']
  },
  {
    name: 'Loss',
    value: ListingStatusEnum.Loss,
    permissions: ['can_update_listings_status']
  },
  {
    name: 'Bundled',
    value: ListingStatusEnum.Bundled,
    permissions: ['can_update_listings_status']
  }
];

export const statusActionMap = {
  [ListingMenuEnum.SetOnHold]: ListingStatusEnum.OnHold,
  [ListingMenuEnum.SetAvailable]: ListingStatusEnum.Available,
  [ListingMenuEnum.SetPurchased]: ListingStatusEnum.Purchased,
  [ListingMenuEnum.SetDefective]: ListingStatusEnum.Defective,
  [ListingMenuEnum.SetLoss]: ListingStatusEnum.Loss,
  [ListingMenuEnum.Edit]: undefined,
  [ListingMenuEnum.Delete]: undefined,
  [ListingMenuEnum.ViewHistory]: undefined
};
